
const FooterSection = () => (
  <div className="footer">
    <div className="container">
      <p>Copyright 2026 Cryptographic Designers, LLC. All rights reserved</p>
    </div>
  </div>
);

export default FooterSection;
